import React from "react";
import clsx from 'clsx';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const blockStyles = makeStyles(theme => ({
  root: {
    width: 45,
    height: 45
  }
}));

const MybilioTextBronze = (props) => {

  const classes = blockStyles();
  const { className } = props;

  return (
    <SvgIcon className = { clsx(classes.root, className) }
             titleAccess = 'Xavin'
             viewBox = { "0 0 45 45" } >
                          <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                width="100%" viewBox="0 0 449 451" enableBackground="new 0 0 449 451">
              <path fill="#084766" opacity="1.000000" stroke="none" d="M450.000000,351.000000
                C450.000000,359.354218 450.000000,367.708466 449.619324,376.687744
                C449.056244,379.106506 449.082123,380.951019 448.659302,382.686188
                C444.146881,401.205078 435.271088,417.035797 420.834076,429.846924
                C412.066345,437.627289 402.371277,443.442261 391.319763,446.930023
                C384.674957,449.027039 377.781647,450.336578 371.000000,452.000000
                C365.645081,452.000000 360.290131,452.000000 354.303864,451.614136
                C333.683655,449.486755 316.436584,441.677246 302.142944,427.602448
                C289.344666,415.000061 276.741272,402.199982 264.013794,389.525330
                C250.709213,376.276001 237.359192,363.072296 224.016785,349.500488
                C223.386780,348.208191 222.911697,347.120819 222.129639,346.341583
                C211.636612,335.886230 201.127548,325.446564 190.546860,315.080109
                C188.944229,313.509949 186.959061,312.330261 185.007721,310.659149
                C169.562057,295.176941 154.259491,280.005493 138.974106,264.490631
                C151.658524,251.339249 164.324051,238.529633 177.008926,225.739197
                C177.199936,225.546631 177.630646,225.591797 178.232574,225.754578
                C193.668869,241.056503 208.822067,256.129822 223.982788,271.549927
                C224.664291,272.996094 225.157028,274.274658 226.039749,275.167664
                C237.218613,286.476746 248.437210,297.746826 259.706635,308.965576
                C260.570007,309.825073 261.893524,310.222382 263.314514,310.975159
                C287.532440,335.025208 311.404358,358.969482 335.389526,382.799713
                C338.378235,385.769104 341.708832,388.574097 345.325439,390.698700
                C356.908691,397.503204 370.195496,396.820557 380.520294,388.795471
                C398.495392,374.823975 397.589905,351.265076 382.907288,337.128632
                C358.084564,313.229370 334.123688,288.434967 309.924561,263.694336
                C316.563995,256.776245 323.019104,250.119949 329.611786,243.602768
                C335.950165,237.336929 342.430908,231.215103 348.992249,225.340805
                C376.020111,252.865189 403.174713,279.821106 429.587341,307.485413
                C435.691620,313.878967 439.910736,322.383881 443.783936,330.496490
                C446.825867,336.867920 447.997498,344.132294 450.000000,351.000000
              z"/>
              <path fill="#084766" opacity="1.000000" stroke="none"
                d="M1.000000,101.000000
                C1.000000,93.645744 1.000000,86.291496 1.382217,78.309952
                C2.245306,74.289566 2.325671,70.780472 3.269494,67.521446
                C11.949194,37.550423 30.666580,16.629143 60.194748,6.124932
                C73.822861,1.276929 88.029526,0.927524 102.390747,2.902611
                C116.387772,4.827611 129.091110,9.798167 139.958679,18.638290
                C148.648499,25.706957 156.777832,33.509537 164.782425,41.366879
                C184.626160,60.845592 204.256012,80.542183 223.994980,100.497658
                C236.903336,113.713615 249.788513,126.583168 262.915131,139.657043
                C278.585419,155.250473 294.014221,170.639557 309.393127,186.385345
                C297.008453,199.174622 284.680939,211.614441 272.314117,224.015030
                C271.784515,224.546082 270.891479,224.714706 270.025208,224.733276
                C254.654816,209.241776 239.426956,194.069168 224.142670,178.551758
                C223.758301,177.645859 223.530762,176.985184 223.087677,176.538208
                C211.554123,164.903442 200.014023,153.275009 188.414261,141.706421
                C187.543060,140.837570 186.218369,140.423431 184.946335,139.508636
                C159.948120,114.402725 135.123215,89.570862 110.256584,64.780861
                C104.540916,59.082806 97.392410,55.847721 89.534500,55.118008
                C76.211105,53.880741 63.804749,60.493187 57.303387,74.224380
                C51.217545,87.077980 53.339737,100.285324 62.615021,109.839188
                C87.639305,135.615097 113.383217,160.692383 138.757538,186.363220
                C126.481674,198.932190 114.302315,211.197357 102.067535,223.406998
                C101.319763,224.153229 100.133148,224.459717 99.007736,224.659882
                C74.285637,199.773773 49.592472,175.311020 25.188269,150.563339
                C16.468218,141.720551 9.753587,131.361526 6.029001,119.356598
                C4.150089,113.300583 2.663813,107.122749 1.000000,101.000000
              z"/>
              <path fill="#65C8F3" opacity="1.000000" stroke="none"
                d="M262.673645,139.452698
                C249.788513,126.583168 236.903336,113.713615 224.296814,100.341751
                C249.035950,75.406914 273.396332,50.872894 298.010773,26.596478
                C306.734467,17.992537 316.632111,10.820513 328.424164,6.844587
                C334.873169,4.670175 341.469879,2.933873 348.000000,1.000002
                C356.687561,1.000000 365.375122,1.000000 374.747192,1.325964
                C386.176849,3.187842 396.159332,6.946321 405.554352,12.260325
                C420.962494,20.975473 432.407928,33.526051 439.911957,49.452301
                C446.977295,64.447517 449.936462,80.149750 448.158661,96.938652
                C446.046600,116.884193 438.911835,134.300964 424.854431,148.557220
                C401.950134,171.785553 378.758301,194.730316 355.704712,217.811630
                C353.360443,220.158722 351.131561,222.621140 348.849121,225.030029
                C342.430908,231.215103 335.950165,237.336929 329.611786,243.602768
                C323.019104,250.119949 316.563995,256.776245 309.643250,263.853027
                C298.863129,274.592499 288.488495,284.850647 277.936768,294.806091
                C276.665436,293.779999 275.624298,292.955627 274.468964,292.348541
                C258.967529,284.202606 243.450195,276.086975 228.079727,267.661102
                C242.204346,253.256302 256.186066,239.154236 270.167755,225.052170
                C270.891479,224.714706 271.784515,224.546082 272.314117,224.015030
                C284.680939,211.614441 297.008453,199.174622 309.613098,186.165955
                C335.077240,160.405823 360.344147,135.293839 385.423096,109.995552
                C393.349670,101.999641 395.649963,91.835548 393.426178,81.110847
                C390.694061,67.934570 381.807739,59.888493 369.161285,56.220131
                C356.658936,52.593575 345.921783,56.808746 337.054840,65.548462
                C314.766205,87.517265 292.749329,109.761719 270.605469,131.877625
                C268.019318,134.460510 265.320343,136.930405 262.673645,139.452698
              z"/>
              <path fill="#65C8F3" opacity="1.000000" stroke="none"
                d="M99.150711,224.970795
                C100.133148,224.459717 101.319763,224.153229 102.067535,223.406998
                C114.302315,211.197357 126.481674,198.932190 138.915955,186.057526
                C149.115540,175.618195 159.072708,165.800888 169.377319,156.035706
                C174.717560,158.680801 179.742096,161.214752 184.696808,163.878540
                C196.487839,170.217743 208.245850,176.618362 219.895554,183.306854
                C205.832428,197.588379 191.890961,211.557205 177.949493,225.526016
                C177.630646,225.591797 177.199936,225.546631 177.008926,225.739197
                C164.324051,238.529633 151.658524,251.339249 138.685944,264.662964
                C113.757591,289.781494 89.336014,314.590912 64.410400,338.883148
                C54.717712,348.329498 50.143177,365.184326 58.501316,379.198639
                C64.828194,389.807068 77.547691,395.754456 87.708580,395.536865
                C97.964218,395.317200 106.203400,390.390320 113.308395,383.224030
                C126.441330,369.977875 139.696045,356.852539 152.853958,343.631012
                C163.654266,332.778503 174.387741,321.859497 185.150848,310.969940
                C186.959061,312.330261 188.944229,313.509949 190.546860,315.080109
                C201.127548,325.446564 211.636612,335.886230 222.129639,346.341583
                C222.911697,347.120819 223.386780,348.208191 223.714783,349.656189
                C198.688309,374.868469 173.973770,399.599091 149.184219,424.254303
                C146.384766,427.038605 143.329514,429.633484 140.109100,431.915771
                C119.795738,446.311493 97.058807,451.349030 72.825943,446.850983
                C39.239323,440.616699 16.701107,420.630249 5.077683,388.525909
                C3.263586,383.515289 2.336989,378.183350 1.000000,373.000000
                C1.000000,364.979095 1.000000,356.958191 1.329135,348.245575
                C1.909790,345.762482 2.034269,343.942322 2.432436,342.184174
                C6.509578,324.180878 15.452532,308.934906 28.507809,295.965912
                C44.892174,279.689850 61.200607,263.337158 77.503586,246.979416
                C84.767410,239.691177 91.937874,232.309860 99.150711,224.970795
              z"/>
              <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="M1.000000,373.468658
                C2.336989,378.183350 3.263586,383.515289 5.077683,388.525909
                C16.701107,420.630249 39.239323,440.616699 72.825943,446.850983
                C97.058807,451.349030 119.795738,446.311493 140.109100,431.915771
                C143.329514,429.633484 146.384766,427.038605 149.184219,424.254303
                C173.973770,399.599091 198.688309,374.868469 223.727005,350.004395
                C237.359192,363.072296 250.709213,376.276001 264.013794,389.525330
                C276.741272,402.199982 289.344666,415.000061 302.142944,427.602448
                C316.436584,441.677246 333.683655,449.486755 353.836243,451.614136
                C236.452576,452.000000 118.905136,452.000000 1.000000,452.000000
                C1.000000,425.980194 1.000000,399.958771 1.000000,373.468658
              z"/>
              <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="M348.992249,225.340820
                C351.131561,222.621140 353.360443,220.158722 355.704712,217.811630
                C378.758301,194.730316 401.950134,171.785553 424.854431,148.557220
                C438.911835,134.300964 446.046600,116.884193 448.158661,96.938652
                C449.936462,80.149750 446.977295,64.447517 439.911957,49.452301
                C432.407928,33.526051 420.962494,20.975473 405.554352,12.260325
                C396.159332,6.946321 386.176849,3.187842 375.215851,1.325964
                C399.974243,1.000000 424.948486,1.000000 450.000000,1.000000
                C450.000000,117.354218 450.000000,233.708450 450.000000,350.531342
                C447.997498,344.132294 446.825867,336.867920 443.783936,330.496490
                C439.910736,322.383881 435.691620,313.878967 429.587341,307.485413
                C403.174713,279.821106 376.020111,252.865189 348.992249,225.340820
              z"/>
              <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="M347.531342,1.000002
                C341.469879,2.933873 334.873169,4.670175 328.424164,6.844587
                C316.632111,10.820513 306.734467,17.992537 298.010773,26.596478
                C273.396332,50.872894 249.035950,75.406914 224.273621,99.995331
                C204.256012,80.542183 184.626160,60.845592 164.782425,41.366879
                C156.777832,33.509537 148.648499,25.706957 139.958679,18.638290
                C129.091110,9.798167 116.387772,4.827611 102.390747,2.902611
                C88.029526,0.927524 73.822861,1.276929 60.194748,6.124932
                C30.666580,16.629143 11.949194,37.550423 3.269494,67.521446
                C2.325671,70.780472 2.245306,74.289566 1.382217,77.841331
                C1.000000,52.359837 1.000000,26.719677 1.000000,1.000000
                C116.354218,1.000000 231.708450,1.000000 347.531342,1.000002
              z"/>
              <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="M99.007736,224.659882
                C91.937874,232.309860 84.767410,239.691177 77.503586,246.979416
                C61.200607,263.337158 44.892174,279.689850 28.507809,295.965912
                C15.452532,308.934906 6.509578,324.180878 2.432436,342.184174
                C2.034269,343.942322 1.909790,345.762482 1.329135,347.776917
                C1.000000,265.979095 1.000000,183.958206 1.000000,101.468658
                C2.663813,107.122749 4.150089,113.300583 6.029001,119.356598
                C9.753587,131.361526 16.468218,141.720551 25.188269,150.563339
                C49.592472,175.311020 74.285637,199.773773 99.007736,224.659882
              z"/>
              <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="M371.468658,452.000000
                C377.781647,450.336578 384.674957,449.027039 391.319763,446.930023
                C402.371277,443.442261 412.066345,437.627289 420.834076,429.846924
                C435.271088,417.035797 444.146881,401.205078 448.659302,382.686188
                C449.082123,380.951019 449.056244,379.106506 449.619324,377.156372
                C450.000000,401.928772 450.000000,426.857544 450.000000,452.000000
                C423.979492,452.000000 397.958405,452.000000 371.468658,452.000000
              z"/>
              <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="M185.007736,310.659149
                C174.387741,321.859497 163.654266,332.778503 152.853958,343.631012
                C139.696045,356.852539 126.441330,369.977875 113.308395,383.224030
                C106.203400,390.390320 97.964218,395.317200 87.708580,395.536865
                C77.547691,395.754456 64.828194,389.807068 58.501316,379.198639
                C50.143177,365.184326 54.717712,348.329498 64.410400,338.883148
                C89.336014,314.590912 113.757591,289.781494 138.668762,265.006409
                C154.259491,280.005493 169.562057,295.176941 185.007736,310.659149
              z"/>
              <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="M278.113861,295.108795
                C288.488495,284.850647 298.863129,274.592499 309.519104,264.175659
                C334.123688,288.434967 358.084564,313.229370 382.907288,337.128632
                C397.589905,351.265076 398.495392,374.823975 380.520294,388.795471
                C370.195496,396.820557 356.908691,397.503204 345.325439,390.698700
                C341.708832,388.574097 338.378235,385.769104 335.389526,382.799713
                C311.404358,358.969482 287.532440,335.025208 263.442017,310.675293
                C268.210083,305.192749 273.161957,300.150787 278.113861,295.108795
              z"/>
              <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="M178.232590,225.754608
                C191.890961,211.557205 205.832428,197.588379 220.193909,183.180542
                C221.808975,181.459885 223.004028,180.178238 224.199097,178.896576
                C239.426956,194.069168 254.654816,209.241776 270.025208,224.733276
                C256.186066,239.154236 242.204346,253.256302 227.792603,267.807404
                C226.233444,269.238678 225.104340,270.220917 223.975250,271.203156
                C208.822067,256.129822 193.668869,241.056503 178.232590,225.754608
              z"/>
              <path fill="#22A3D1" opacity="1.000000" stroke="none"
                d="M223.982788,271.549927
                C225.104340,270.220917 226.233444,269.238678 227.649689,268.110138
                C243.450195,276.086975 258.967529,284.202606 274.468964,292.348541
                C275.624298,292.955627 276.665436,293.779999 277.936768,294.806091
                C273.161957,300.150787 268.210083,305.192749 263.130676,310.534607
                C261.893524,310.222382 260.570007,309.825073 259.706635,308.965576
                C248.437210,297.746826 237.218613,286.476746 226.039749,275.167664
                C225.157028,274.274658 224.664291,272.996094 223.982788,271.549927
              z"/>
              <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="M262.915100,139.657043
                C265.320343,136.930405 268.019318,134.460510 270.605469,131.877625
                C292.749329,109.761719 314.766205,87.517265 337.054840,65.548462
                C345.921783,56.808746 356.658936,52.593575 369.161285,56.220131
                C381.807739,59.888493 390.694061,67.934570 393.426178,81.110847
                C395.649963,91.835548 393.349670,101.999641 385.423096,109.995552
                C360.344147,135.293839 335.077240,160.405823 309.663025,185.809250
                C294.014221,170.639557 278.585419,155.250473 262.915100,139.657043
              z"/>
              <path fill="#FFFFFF" opacity="1.000000" stroke="none"
                d="M169.029877,155.983582
                C159.072708,165.800888 149.115540,175.618195 138.999969,185.741196
                C113.383217,160.692383 87.639305,135.615097 62.615021,109.839188
                C53.339737,100.285324 51.217545,87.077980 57.303387,74.224380
                C63.804749,60.493187 76.211105,53.880741 89.534500,55.118008
                C97.392410,55.847721 104.540916,59.082806 110.256584,64.780861
                C135.123215,89.570862 159.948120,114.402725 184.643448,139.685349
                C179.342422,145.428741 174.186142,150.706161 169.029877,155.983582
              z"/>
              <path fill="#23A5D4" opacity="1.000000" stroke="none"
                d="M169.377319,156.035706
                C174.186142,150.706161 179.342422,145.428741 184.801590,139.974609
                C186.218369,140.423431 187.543060,140.837570 188.414261,141.706421
                C200.014023,153.275009 211.554123,164.903442 223.087677,176.538208
                C223.530762,176.985184 223.758301,177.645859 224.142685,178.551758
                C223.004028,180.178238 221.808975,181.459885 220.315567,182.867844
                C208.245850,176.618362 196.487839,170.217743 184.696808,163.878540
                C179.742096,161.214752 174.717560,158.680801 169.377319,156.035706
              z"/>
              </svg>

    </SvgIcon>
  );
}

export default MybilioTextBronze;
